export const app_env = "prod";

export const app_api_url = "https://www.tidolasab.com/api";

export const priceLowSeason = 100;
export const priceHightSeason = 110;
export const touristTax = 2;

export const DEFAULT_MAX_LENGTH = 5;
